declare global {
  interface Window {
    fbq?: (...args: any[]) => void
  }
}

export const metaTrack = (event: string, params: Record<string, any> = {}) => {
  if (typeof window === 'undefined') return
  if (typeof window.fbq !== 'function') return
  window.fbq('track', event, params)
}
